export enum Bundle {
    Product = 'product',
    Story = 'story',
    Flow = 'flow',
}
